// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'

import config from 'SrcConfig'

import PortalVue from 'portal-vue'
import {BootstrapVue,BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueI18n from 'vue-i18n'
import Config from './plugins/config'
import roles from "./plugins/roles";
import Mixin from './plugins/global-mixins'

import Api from './plugins/api'
import Dir from './plugins/dir'
import Messages from './plugins/messages'
import Meta from 'vue-meta'
import Snotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueCookies from 'vue-cookies'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Multiselect from 'vue-multiselect'
import JsonExcel from 'vue-json-excel'
import { Plugin } from 'vue-fragment'
import HighchartsVue from 'highcharts-vue'
import Print from 'vue-print-nb'
import VueClipboard from 'vue-clipboard2'
import { VueMaskDirective } from 'v-mask'
import directives from './plugins/directives'
import InputMask from 'vue-input-mask';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import Datepicker from 'vuejs-datepicker';
import ApiAdapter from '@/api';


import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.use(VueCookies)
import '../src/assets/scss/swiper-bundle.scss'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw',
  }
})
const options = {
  pk: config.stripeToken
};
Vue.use(HighchartsVue)
Vue.use(PortalVue)

Vue.component('input-mask', InputMask)
Vue.component('en-date-picker', Datepicker)
Vue.directive('mask', VueMaskDirective);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(Config)
Vue.use(Api)
Vue.use(roles)
Vue.use(Mixin)
Vue.use(VueClipboard)
Vue.use(Dir)
Vue.use(Messages)
Vue.use(Meta)
Vue.use(Snotify)
Vue.use(Plugin)
Vue.use(Print);
Vue.use(directives)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
Vue.use(StripePlugin, options);

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas as solid } from '@fortawesome/free-solid-svg-icons'

library.add(solid)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('date-picker', VuePersianDatetimePicker)
Vue.component('multiselect', Multiselect)
Vue.component('downloadExcel', JsonExcel)

Vue.directive('notEmpty', {
  // When the bound element is inserted into the DOM...
  update:  (el) => {
    el.value = !(el.value.trim().length) ? null : el.value
    console.log(el.value.trim().length)
    console.log(el.value)
    // console.log(el.value.split(','))
  },
})

import * as types from './store/types'
import store from './store'
import router from './router'
import { permissionsHaveNamespaces } from '@/lib/account'
import { get as getData } from '@/lib/local-storage'
import {permissionHaveNameSpace} from "./lib/util";
import wb from "./registerServiceWorker";

import firebase from "firebase/compat";
import '@firebase/messaging'

const firebaseConfig = {
  messagingSenderId: "633884622769",
  apiKey: "AIzaSyCb03815dAD4iflIPR5jxxvGVAodkoSCys",
  projectId: "mp-firebase1",
  appId: "1:633884622769:web:0732347850b5eb10ed0790",
}

firebase.initializeApp(firebaseConfig)


Vue.prototype.$workbox = wb;
// Set Account ----------------------------------------
let account = getData(types.ACCOUNT_COOKIE)
if (account) {
  store.commit(types.SET_ACCOUNT, account)
}
// ---------------------------------------------------

router.beforeEach((to, from, next) => {
  let allowed = true
  if (!to.meta.auth) {
    allowed = true
  } else if (permissionHaveNameSpace(to.meta.auth)) {
    allowed = true
  } else {
    allowed = false
  }

  if (!allowed) {
    next('/overview')
  }

  // let account = Promise.resolve()
  if (!to.meta.public) {
    if (!store.state.selectedRestaurantId) {
      Promise.all([
        ApiAdapter(store).getRestaurant.getList(true),
        ApiAdapter(store).getRestaurant.GetCurrentUserInfo(),
      ]).then(res => {
        const restaurantResult = res[0]
        const accountResult = res[1]
  
        localStorage.setItem('userID', restaurantResult.results.UserID)
        const restaurant = restaurantResult.results.RestaurantName
        store.commit(types.RESTAURANTS, restaurant)
        if (localStorage.getItem('selectedRestaurant') === null) {
          localStorage.setItem('selectedRestaurant', restaurant[0].Value)
          localStorage.setItem('selectedRestaurantName', restaurant[0].Text)
          store.commit(types.CHANGERESTAURANT, restaurant[0].Value)
        } else {
          store.commit(types.CHANGERESTAURANT, localStorage.getItem('selectedRestaurant'))
        }
  
        store.commit(types.CLIENT_TYPE_ID, accountResult.results.ClientTypeID);
        localStorage.setItem("ClientTypeID", accountResult.results.ClientTypeID);
        localStorage.setItem("RoleID", accountResult.results.RoleID);
        localStorage.setItem("userInfo", accountResult.results.FirstName + ' ' + accountResult.results.LastName);
  
        const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
        if (navigator.permissions) {
          navigator.permissions.query({name: 'notifications'}).then(res => {
            localStorage.setItem('notifStatus', res.state)
            if (res.state === 'granted') {
              store.commit(types.NOTIF_FIREBASE, false)
              if (messaging) {
                return messaging.getToken().then(token => {
                  store.commit(types.SET_FIREBASE, token)
                  const model = {
                    // UserID: restaurantResult.results.UserID,
                    RestaurantID: localStorage.getItem('selectedRestaurant'),
                    FireBaseToken: token
                  }
                  ApiAdapter(store).getRestaurant.UpdateRestaurantFirebaseUsers(model).then(res => {
                    // console.log(res)
                  })
                }).catch(err => {
                  console.log(`err firebase: ${err}`)
                })
              }
            } else {
              store.commit(types.NOTIF_FIREBASE, true)
            }
          })
        }
        next()
      })
    } else {
      ApiAdapter(store).getRestaurant.GetCurrentUserInfo().then(res => {
        const accountResult = res
        store.commit(types.CLIENT_TYPE_ID, accountResult.results.ClientTypeID);
        localStorage.setItem("ClientTypeID", accountResult.results.ClientTypeID);
        localStorage.setItem("RoleID", accountResult.results.RoleID);
        localStorage.setItem("userInfo", accountResult.results.FirstName + ' ' + accountResult.results.LastName);
        next()
      })
    }
  } else {
    next()
  }
  

  // account.then(res => {
  //   store.commit(types.CLIENT_TYPE_ID, res.results.ClientTypeID);
  //   localStorage.setItem("ClientTypeID", res.results.ClientTypeID);
  //   localStorage.setItem("RoleID", res.results.RoleID);
  // })


  // promise.then((res) => {
  //   localStorage.setItem('userID', res.results.UserID)
  //   const restaurant = res.results.RestaurantName
  //   store.commit(types.RESTAURANTS, restaurant)
  //   if (localStorage.getItem('selectedRestaurant') === null) {
  //     localStorage.setItem('selectedRestaurant', restaurant[0].Value)
  //     localStorage.setItem('selectedRestaurantName', restaurant[0].Text)
  //     store.commit(types.CHANGERESTAURANT, restaurant[0].Value)
  //   } else {
  //     store.commit(types.CHANGERESTAURANT, localStorage.getItem('selectedRestaurant'))
  //   }
  // })

})

router.afterEach(() => {
  for(let i=0; i < 1000000; i++)
  {
    window.clearInterval(i);
  }
})

/* eslint-disable no-new */

import i18nMessages from './i18n'
const i18n = new VueI18n({
  locale: config.locale,
  fallbackLocale: 'en',
  messages: i18nMessages
})

import App from './App'

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  },
  beforeCreate () {
    // let locale = getData(types.LOCALE_COOKIE) || config.locale
    // this.$store.commit(types.SET_LOCALE, {
    //   value: locale,
    //   validator: this.$validator,
    //   i18n: this.$i18n
    // })
  }
})

// LocalServiceWorkerRegister()
